export function createEventSchemaRegistryClient(transport) {
    return {
        /**
         * GET /health/live
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getLiveness(options) {
            return transport.request({
                method: "GET",
                path: "/health/live",
                options,
            });
        },
        /**
         * GET /health/ready
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getReadiness(options) {
            return transport.request({
                method: "GET",
                path: "/health/ready",
                options,
            });
        },
        /**
         * POST /internal/v1/subjects/{subject}/versions
         *
         * Requires scope: event-schema:publish
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        registerEventSchema(subject, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/subjects/${encodeURIComponent(subject)}/versions`,
                body,
                options,
            });
        },
        /**
         * GET /internal/v1/subjects/{subject}/versions/{version}
         *
         * Requires scope: event-schema:read
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getEventSchema(subject, version, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/subjects/${encodeURIComponent(subject)}/versions/${encodeURIComponent(version)}`,
                options,
            });
        },
        /**
         * POST /internal/v1/subjects/{subject}/compatibility
         *
         * Requires scope: event-schema:validate
         */
        validateEventSchemaCompatibility(subject, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/subjects/${encodeURIComponent(subject)}/compatibility`,
                body,
                options,
            });
        },
        /**
         * List every registered event contract as identity and state, across all subjects
         *
         * Requires scope: event-schema:platform:read
         */
        listPlatformEventSchemas(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/event-schemas",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=event-schema-registry.js.map